// extracted by mini-css-extract-plugin
export default {"header_title_wrapper":"HeaderTitle_header_title_wrapper__ON5kI","lowercaseText":"HeaderTitle_lowercaseText__mWi51"};